const Color = {
  color: "#1462C8",
  hover: "#0D3E80",
  textColor: "#575757",
  label: "#000000",
  sideBarTab: "#E7EFF9",
  darkBlue: "#0D3E80",
};

export { Color };
